import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundErrorComponent } from '../main/error-page/not-found-error/not-found-error';
import { TenantLayoutComponent } from './tenant-layout.component';
const routes: Routes = [{
  path: '',
  component: TenantLayoutComponent,
  children: [
    {
      path: 'service-error',
      loadChildren: () => import('src/app/main/service-error/service-error.module').then(m => m.ServiceErrorModule)
    },
    {
      path: 'permission-unauthorized',
      loadChildren: () => import('src/app/main/permission-unauthorized/permission-unauthorized.module').then(m => m.PermissionUnauthorizedModule)
    },
    {
      path: '',
      loadChildren: () => import('src/app/main/gettenant/gettenant.module').then(m => m.GettenantModule)
    },
    {
      path: ':id/blueprints',
      loadChildren: () => import('src/app/main/service-definition/service-definition.module').then(m => m.ServiceDefinitionModule)
    },
    {
      path: ':id/dashboard',
      loadChildren: () => import('src/app/main/tenant-dashboard/tenant-dashboard.module').then(m => m.TenantDashboardModule)
    },
    {
      path: ':id/subscription',
      loadChildren: () => import('src/app/main/tenant-subscription/subscription-mgmt-list.module').then(m => m.SubscriptionMgmtListModule)
    },
    {
      path: ':id/edge-network',
      loadChildren: () => import('src/app/main/tenant-edge-network/edge-network.module').then(m => m.EdgeNetworkModule)
    },
    {
      path: ':id/certificate',
      loadChildren: () => import('src/app/main/tenant-certification/tenant-certification.module').then(m => m.TenantCertificationModule)
    },
    {
      path: ':id/shared-services',
      loadChildren: () => import('src/app/main/tenant-shared-services/shared-services.module').then(m => m.SharedServicesModule)
    },
    {
      path: ':id/updates',
      loadChildren: () => import('src/app/main/tenant-continuous-update/tenant-continuous-update.module').then(m => m.TenantContinuousUpdateModule)
    },
    {
      path: ':id/blueprints/:blueprintId',
      loadChildren: () => import('src/app/main/blueprint-summary/blueprint-summary.module').then(m => m.BlueprintSummaryModule)
    },
    {
      path: ':id/blueprints/:blueprintId/environment/:instanceId/featureFlag',
      loadChildren: () => import('src/app/main/feature-flag/feature-flag.module').then(m => m.FeatureFlagModule)
    },
    {
      path: ':id/solutions',
      loadChildren: () => import('src/app/main/tenant-solutions/tenant-solutions.module').then(m => m.TenantsSolutionsModule)
    },
    {
      path: ':id/disaster-recovery',
      loadChildren: () => import('src/app/main/tenant-disaster-recovery/tenant-disaster-recovery.module').then(m => m.TenantDisasterRecoveryModule)
    },
    {
      path: ':id/settings',
      loadChildren: () => import('src/app/main/tenant-settings/tenant-settings.module').then(m => m.TenantSettingsModule)
    },
    {
      path: ':id/jumpbox',
      loadChildren: () => import('src/app/main/tenant-jumpbox/tenant-jumpbox.module').then(m => m.TenantJumpboxModule)
    },
    {
      path: ':id/schedule',
      loadChildren: () => import('src/app/main/tenant-schedule/tenant-schedule.module').then(m => m.TenantScheduleModule)
    },
    {
      path: ':id/schedule/:scheduleId',
    loadChildren: () => import('src/app/main/tenant-schedule-details/tenant-schedule-details.module').then(m => m.TenantScheduleDetailsModule)
    },
    {
      path: ':id/custom-image',
      loadChildren: () => import('src/app/main/tenant-custom-image/tenant-custom-image.module').then(m => m.TenantCustomImageModule)
    },
    {
      path: ':id/custom-image/:custom-imageId',
      loadChildren: () => import('src/app/main/tenant-custom-image-details/tenant-custom-image-details.module').then(m => m.TenantCustomImageDetailsModule)
    },
    // {
    //   path: ':id/external-package',
    //   loadChildren: () => import('src/app/main/external-package/external-package.module').then(m => m.ExternalPackageModule)
    // },
    {
      path: ':id/EOLReport',
      loadChildren: () => import('src/app/main/power-bi-report/power-bi-report.module').then(m => m.PowerBiReportModule)
    },
    {
      path: ':id/featureFlag',
      loadChildren: () => import('src/app/main/feature-flag/feature-flag.module').then(m => m.FeatureFlagModule)
    },
    {
      path: '**',
      component: NotFoundErrorComponent
    }
  ]

}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantLayoutRoutingModule {
}
